import React, { memo } from "react";
import PropTypes from "prop-types";
import { Chip, Tooltip } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import LinkIcon from "@mui/icons-material/Link";

const CuotaExcedidaChip = memo(({ clase, cuotaInicial, cuotaFinal, clasesVinculadas = [] }) => {
  const getMensaje = () => {
    const rangoTexto = `${cuotaInicial} a ${cuotaFinal}`;
    if (clasesVinculadas.length > 0) {
      return `Las cuotas ${rangoTexto} de las clases vinculadas ${[clase, ...clasesVinculadas].join(
        ", "
      )} exceden el disponible`;
    }
    return `Las cuotas ${rangoTexto} de ${clase} exceden el disponible`;
  };

  const getLabel = () => {
    if (clasesVinculadas.length > 0) {
      return `${clase} + ${clasesVinculadas.join("+")} (${cuotaInicial}-${cuotaFinal})`;
    }
    return `${clase}: ${cuotaInicial}-${cuotaFinal}`;
  };

  return (
    <Tooltip title={getMensaje()}>
      <Chip
        icon={clasesVinculadas.length > 0 ? <LinkIcon /> : <WarningIcon />}
        label={getLabel()}
        color="warning"
        variant="outlined"
        sx={{
          "& .MuiChip-label": {
            whiteSpace: "normal",
            fontWeight: clasesVinculadas.length > 0 ? "bold" : "normal",
          },
          borderColor: "warning.main",
          "& .MuiChip-icon": {
            color: "warning.main",
            transform: clasesVinculadas.length > 0 ? "rotate(45deg)" : "none",
          },
        }}
      />
    </Tooltip>
  );
});

CuotaExcedidaChip.propTypes = {
  clase: PropTypes.string.isRequired,
  cuotaInicial: PropTypes.number.isRequired,
  cuotaFinal: PropTypes.number.isRequired,
  excedente: PropTypes.number.isRequired,
  clasesVinculadas: PropTypes.arrayOf(PropTypes.string),
};

CuotaExcedidaChip.displayName = "CuotaExcedidaChip";

export default CuotaExcedidaChip;
